import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { requestData } from '../js/api.js'
import { calculatePrice, checkUnit, calculateDaysBetween } from '../js/function.js'
import { useNavigate } from "react-router-dom";
import AlertWindow from '../components/Alert'

function CheckBooking() {
  // const dispatch = useDispatch();
  const { orderID, lastname } = useParams();
  const [res, setRes] = useState({})
  const navigate = useNavigate();
  const images = require.context('../img', false, /\.svg$/);
  const [openAlert, setOpenAlert] = useState(false)
  const alertMessage = useState('Please filled in all information')
  const initData = useSelector((state) => state.data.initData);
  const [days, setDays] = useState(0)
  const [viewBookingData, setViewBookingData] = useState({
    orderID: '',
    lastname: '',
  })
  const [basePrice,setBasePrice] = useState(0)
  const [loading, setLoading] = useState(true)
  const [relocationFee, setRelocationFee] = useState('0')
  const [youngdriverFee, setYoungdriverFee] = useState('0')
  const [olddriverFee, setOlddriverFee] = useState('0')

  const getRelocationFee = async () => {
    try {
      let data = await requestData('GET', 'relocation');
      if (data.success) {
        setRelocationFee(data.price)
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  const getYoungAge = async () => {
    try {
      let data = await requestData('GET', 'youngdrivesurcharge');
      if (data.success) {
        setYoungdriverFee(data.price)
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  const getOldAge = async () => {
    try {
      let data = await requestData('GET', 'olddrivesurcharge');
      if (data.success) {
        setOlddriverFee(data.price)
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  useEffect(() => {
    getRelocationFee()
    getYoungAge()
    getOldAge()
  }, [])

  const handleChange = (event, key) => {
    setViewBookingData(prevState => ({
      ...prevState,
      [key]: event.target.value
    }));
  }

  const checkOrderID = async () => {
    if (viewBookingData.orderID !== '' && viewBookingData.lastname !== '') {
      navigate("/viewbooking/" + viewBookingData.orderID + '/' + viewBookingData.lastname)
      // closeEvent()
    } else {
      // alert('please filled in all data')
      setOpenAlert(true)
    }
  }

  // useEffect(() => {
  //   setDays(calculateDaysBetween(res?.ta?.startDate, res?.searchdata?.startTime, res?.searchdata?.endDate, res?.searchdata?.endTime))
  //   setBasePrice(calculatePrice(res?.searchdata, res?.selectedextraoptions, itemPrice))
  // }, [res, itemPrice])

  useEffect(() => {
    setDays(calculateDaysBetween(res.searchdata?.startDate, res.searchdata?.startTime, res.searchdata?.endDate, res.searchdata?.endTime))
    setBasePrice(calculatePrice(res.searchdata?.vehiclePrice,initData,res?.searchdata,days,res?.selectedextraoptions,relocationFee,youngdriverFee,olddriverFee))
  }, [res,days,initData])  // eslint-disable-line

  useEffect(() => {
    const getOrderDetails = async () => {
      try {
        const data = await requestData('POST', 'checkviewbooking', { orderID: orderID, lastname: lastname });
        if (data.length > 0) {
          setRes(data[0])
        } else {
          setRes({})
        }
        setLoading(false)
      } catch (error) {
        console.error('Error:', error.message);
      }
    }
    getOrderDetails()
  }, [orderID, lastname])

  const handleBackHome = () => {
    navigate("/")
  }
  return (
    <div className="text-start p-3">
      <button onClick={handleBackHome} className='mb-3 text-gray-500 px-2'>
        &larr;&nbsp;Back to Home
      </button>
      <div className='mt-3 text-2xl font-semibold pb-2'>
        <span className="px-4 block text-gray-900 font-bold">Booking Review</span>
      </div>
      {loading === true && <div className='p-8 relative items-center w-screen h-screen'>
        <div role="status" class="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
          <svg aria-hidden="true" class="w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>}
      {!loading && Object.keys(res || {}).length === 0 ?
        <div className='px-4'>
          No match order, please check the details and try again.
          <div class="p-4 md:p-5 space-y-4">
            <div class="flex flex-col">
              <label for="orderid" class="text-sm font-medium text-gray-600 text-start">Order ID <span class="text-red-500">*</span></label>
              <input value={viewBookingData.orderID} onChange={(event) => handleChange(event, 'orderID')} type="text" id="orderid" placeholder="e.g. dl-..." class="mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2 " />
            </div>
            <div class="flex flex-col">
              <label for="lastName" class="text-sm font-medium text-gray-600 text-start">Last Name <span class="text-red-500">*</span></label>
              <input value={viewBookingData.lastname} onChange={(event) => handleChange(event, 'lastname')} type="text" id="lastName" placeholder="e.g. Li..." class="mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2" />
            </div>
          </div>
          <div class="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600" onClick={checkOrderID}>
            <button data-modal-hide="default-modal" type="button" class="text-white bg-primary focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center">View Now</button>
          </div>
        </div> : null}
      {!loading && Object.keys(res || {}).length !== 0 ?
        <div className=''>
          <div className="px-4 block text-gray-400 text-sm border-b-2 pb-2 border-gray-200">Order ID: {orderID}</div>
          {/* <div className="px-4 block text-gray-400 pb-2 text-sm border-b-2 border-gray-200">Order Date:</div> */}
          <div className="mb-3 text-left max-w-2xl mx-auto">
            <div className="px-4 w-full py-4 border-b-2 border-gray-200">
              <div className="text-l text-gray-800">Pickup / Return</div>
              <div className='mt-2'>
                <div className='text-gray-400 text-sm'>Pickup</div>
                <div className='font-bold'>{initData.branches?.[res.searchdata?.pickup].name}</div>
                <div className='font-bold'>{res.searchdata?.startDate + ' - ' + res.searchdata?.startTime}</div>
              </div>
              <div className='mt-2'>
                <div className='text-gray-400 text-sm'>Return</div>
                <div className='font-bold'>{res.searchdata?.dropoff === 'same_as_pickup' ? 'Same as pick up' : initData.branches?.[res.searchdata?.dropoff].name}</div>
                <div className='font-bold'>{res.searchdata?.endDate + ' - ' + res.searchdata?.endTime}</div>
              </div>
              <div className='mt-2'>
                <div className='text-gray-400 text-sm'>Renter Age</div>
                <div className='font-bold'>{res.searchdata?.driverage}</div>
              </div>
            </div>
            <div className="px-4 w-full py-4 border-b-2 border-gray-200">
              <div className="text-l text-gray-800">Vehicle Details</div>
              {res.searchdata?.vehicleDetails && res.searchdata?.vehicleDetails?.length !== 0 ?
                <div>
                  <div className='block'>
                    {res.searchdata?.vehicleDetails.url && <img className='m-auto' alt='vehicleImg' src={res.searchdata?.vehicleDetails.url} />}
                    <div className='flex-1 flex flex-col'>
                      <div className='font-bold'>{res.searchdata?.vehicleDetails.title}</div>
                      <div className='font-bold text-lg mb-1'>{res.searchdata?.vehicleDetails.type}</div>
                      <div className="grid grid-cols-2 gap-x-1 text-sm mt-1">
                        {res.searchdata?.vehicleDetails.specs && res.searchdata?.vehicleDetails.specs.map((i, id) => (
                          <div className='flex items-center' key={id + 'specs'}>
                            <img src={images(`./${i.label}.svg`)} className='w-4 h-4 mr-2' alt={i.label} />
                            <div>{i.value}</div>
                          </div>
                        ))}
                      </div>
                      <div className='group relative inline mt-2 inline-block'>

                        <div className="py-1 text-sm">
                          {res.searchdata?.vehicleDetails.more_info && res.searchdata?.vehicleDetails.more_info.map((data, i) => (
                            <div key={i} className='mb-2 overflow-visible'>
                              <div className='capitalize font-bold'>{data.title}</div>
                              <div className=''>{data.string && data.string}</div>
                              <div className=''>
                                {data.array && data.array.map((d, y) => (
                                  <div key={y} className='whitespace-normal'>+ {d}</div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                : '-'}
            </div>
            <div className="w-full py-4 border-b-2 border-gray-200">
              <div className='mx-4'>
                <div className="text-l text-gray-800">Final Price</div>
                <div className='mt-2'>
                  <div className='text-gray-400 text-sm'>Piricing</div>
                  <div className='font-bold text-sm'>
                    <div className="flex justify-between">
                      <p>Rental Rate</p>
                      <p>${parseFloat(res.searchdata?.vehiclePrice).toFixed(2)}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>{initData.insurance?.[res.searchdata?.damageLiability]?.title}</p>
                      <p>${parseFloat(initData.insurance?.[res.searchdata?.damageLiability]?.price).toFixed(2)}{checkUnit(initData.insurance?.[res.searchdata.damageLiability].unit, days)}</p>
                    </div>
                    {Object.entries(res?.selectedextraoptions || {}).map(([key, value]) => (
                      <div className="flex justify-between" key={key}>
                        <p>{initData.options[key]?.title}</p>
                        <p>${parseFloat(initData.options[key]?.price).toFixed(2)}{checkUnit(initData.options[key]?.unit, days)}</p>
                        {/* <p>${parseFloat(itemPrice[key]?.price).toFixed(2)} x {value}</p> */}
                      </div>
                    ))}
                    <div className="flex justify-between">
                      <p>{initData.included_kilometres?.[res.searchdata?.included_kilometres]?.title}</p>
                      <p>${parseFloat(initData.included_kilometres?.[res.searchdata?.included_kilometres]?.price).toFixed(2)}{checkUnit(initData.included_kilometres?.[res.searchdata?.included_kilometres].unit, days)}</p>
                    </div>
                    
                    <div>
                      {res?.searchData?.dropoff !== 'same_as_pickup' && res?.searchData?.dropoff !== res?.searchData?.pickup && (
                        <div className="flex justify-between">
                          <p>Relocation</p>
                          <p>${relocationFee}</p>
                        </div>
                      )}
                    </div>
                    <div>
                      {res?.searchData?.driverage.includes('21') && (
                        <div className="flex justify-between">
                          <p>Young Driver Fee</p>
                          <p>${youngdriverFee} X {days}</p>
                        </div>
                      )}
                    </div>
                    <div>
                      {res?.searchData?.driverage.includes('65') && (
                        <div className="flex justify-between">
                          <p>Ole Driver Fee</p>
                          <p>${olddriverFee} X {days}</p>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
                <div className='mt-2'>
                  <div className='text-gray-400 text-sm'>Taxes - 10% GST</div>
                  <div className='flex justify-between font-bold text-sm'>
                    <div>GST</div>
                    <div>${(parseFloat(basePrice).toFixed(2) * 0.1).toFixed(2)}</div>
                  </div>
                </div>
              </div>
              <div className='mt-2 py-2 px-4 text-white bg-primary'>
                <div className='font-bold text-lg'>TOTAL</div>
                {/* <div className='font-bold text-xl'>AUD <span className='text-3xl'>{parseFloat(basePrice * 1.1).toFixed(2)}</span></div> */}
                <div className='font-bold text-xl'>AUD <span className='text-3xl'>{parseFloat(basePrice).toFixed(2)}</span></div>

              </div>
            </div>
          </div>
        </div>
        : null
      }
      <AlertWindow setOpenAlert={setOpenAlert} openAlert={openAlert} message={alertMessage} />
    </div >
  );
}

export default CheckBooking;